export class AgentProfileHelper {
  static humaniseProfileKey(profileKey: string): string {
    const words = profileKey.toLowerCase().split('_').filter(Boolean).join(' ');

    return words
      ? `${words.charAt(0).toUpperCase()}${words.slice(1)}`
      : profileKey;
  }

  /** A database profile carries the author's own `title`; a code-registry one has only an ALL_CAPS
   * key. Humanising the key alone would render a stored profile as "User:cmg1x…". */
  static getDisplayName(profile: {
    profileKey: string;
    title?: string;
  }): string {
    return (
      profile.title?.trim() ||
      AgentProfileHelper.humaniseProfileKey(profile.profileKey)
    );
  }
}
